var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M9.9,1.3L7.5,6.6L7.3,7.1L6.8,7.2L1.3,8.1l4.1,4l0.4,0.4L5.6,13l-0.9,5.8L9.6,16l0.5-0.3l0.5,0.3l5,2.6 l-1-5.8l-0.1-0.5l0.3-0.4l4-4.2l-5.5-0.8L12.7,7l-0.2-0.5L9.9,1.3 M9.9,0c0.3,0,0.6,0.2,0.7,0.4l2.8,5.6l6,0.8 c0.3,0,0.5,0.2,0.6,0.5c0.1,0.3,0,0.6-0.2,0.8l-4.3,4.5l1.1,6.2c0.1,0.3-0.1,0.6-0.3,0.8c-0.1,0.1-0.3,0.1-0.5,0.1 c-0.1,0-0.2,0-0.4-0.1l-5.4-2.9l-5.3,3C4.7,20,4.6,20,4.5,20c-0.2,0-0.3,0-0.4-0.1c-0.2-0.2-0.4-0.5-0.3-0.7l0.9-6.3L0.2,8.5 C0,8.3-0.1,8,0,7.7c0.1-0.3,0.3-0.5,0.6-0.5l6-1l2.6-5.7C9.3,0.2,9.6,0,9.9,0C9.9,0,9.9,0,9.9,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarInactive);
export default __webpack_public_path__ + "static/media/icon_star_inactive.7ca9afcb45ef8242b2ee0b97c0df74e3.svg";
export { ForwardRef as ReactComponent };